export default __webpack_public_path__ + "static/media/large.8cdc48ed.jpg";